import type { FaireProductEntity } from "../../entity_types/product";

export const p_fazcexhkjs: FaireProductEntity = {
  token: "p_fazcexhkjs",
  type: "product",
  name: "Farmhouse Stripe Kitchen Towels Set Of 12",
  brandName: "KAF Home",
  imageUrl:
    "https://cdn.faire.com/fastly/7ad4d721c26f1597bd15501421f3bb91632fc3cf4dcf4a55ddeb929fef3cee75.jpeg",
  priceDollars: 12,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/ce1f717516fae572af6a77ebde231a537ee118797e97df3cd3affda638ebf709.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
